import api from "./baseApi.js";
import GenericClass from "../../helpers/generic.js";
export default {
  
  async GetApplications(userId, divisionOrder) {
    var res = await api.get("Login/GetApplicationsByUser/" + userId + "/" + divisionOrder);
        
    res.data.forEach(element => {      
      element.ApplicationUrlApp = GenericClass.ChangeAppUrlDomain(element.ApplicationUrlApp);
      // console.log("ApplicationUrlApp", element.ApplicationUrlApp);
    });
    return res;
  }
}